import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowUpRight, FiCheck } from 'react-icons/fi';
import Reveal from './Reveal';
import { products } from '../data/site';

const ProductSpotlight = ({ productId = 'edtrack', alt = false, showFeatures = true }) => {
  const product = products[productId];

  return (
    <section className={`section ${alt ? 'section-alt' : ''}`}>
      <div className="container product-spotlight">
        <Reveal className="product-copy">
          <span className="eyebrow">Our product</span>
          <h2 className="section-title">{product.name}</h2>
          <p className="product-tagline">{product.tagline}</p>
          <p className="section-subtitle">{product.description}</p>

          <ul className="product-audiences">
            {product.audiences.map((audience) => (
              <li key={audience}>{audience}</li>
            ))}
          </ul>

          <div className="btn-row">
            <a href={product.url} target="_blank" rel="noopener noreferrer" className="btn btn-lg">
              Visit {product.domain} <FiArrowUpRight />
            </a>
            <Link to="/contact" className="btn btn-secondary btn-lg">
              Book a demo
            </Link>
          </div>
        </Reveal>

        <Reveal className="product-shot" delay={0.1}>
          <a href={product.url} target="_blank" rel="noopener noreferrer" className="mock" aria-label={`Open ${product.name}`}>
            <div className="mock-bar">
              <i /><i /><i />
              <span className="mock-url">{product.domain}</span>
            </div>
            <img
              src={product.image.replace('.webp', '-800.webp')}
              srcSet={`${product.image.replace('.webp', '-800.webp')} 800w, ${product.image} 1800w`}
              sizes="(max-width: 1080px) 92vw, 640px"
              width="800"
              height="500"
              alt={`${product.name} website`}
              loading="lazy"
              decoding="async"
            />
          </a>
        </Reveal>
      </div>

      {showFeatures && (
        <div className="container">
          <div className="product-features">
            {product.features.map((feature, index) => (
              <Reveal key={feature.title} className="deliverable" delay={index * 0.04}>
                <span className="deliverable-check"><FiCheck /></span>
                <div>
                  <h3>{feature.title}</h3>
                  <p>{feature.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductSpotlight;
